<template>
  <v-main>
    <section>
      <Title :title="title" :img="img"></Title>
    </section>
    <v-sheet color="backgroundGrayColor" height="auto" style="border: solid rgb(220, 220, 220);">
      <v-container class="mx-auto" style="max-width: 1100px;">
        <!--目次-->
        <v-container pb-12>
          <hr/>
          <h2 class="pt-12 text-h6">▼ 目次</h2>
          <ol class="pt-6 pb-9 px-12 agenda__num">
            <li class="py-2 text-h6">
              <span class="indigo--text text-decoration-underline agenda__list" v-on:click="$vuetify.goTo(target1, options)">MOTPhone、MOTPhone-POPUPを終了</span>
            </li>
            <li class="py-2 text-h6">
              <span class="indigo--text text-decoration-underline agenda__list" v-on:click="$vuetify.goTo(target2, options)">GAIAからMOTPhone更新プログラムをダウンロード</span>
            </li>
            <li class="py-2 text-h6">
              <span class="indigo--text text-decoration-underline agenda__list" v-on:click="$vuetify.goTo(target3, options)">更新プログラム実行</span>
            </li>
            <li class="py-2 text-h6">
              <span class="indigo--text text-decoration-underline agenda__list" v-on:click="$vuetify.goTo(target4, options)">動作確認</span>
            </li>
          </ol>
          <hr/>
          <v-row class="pt-12">
            <h2>【MOTPhone設定更新方法】</h2>
            <p class="px-6">MOTPhoneのバージョンアップや仕様変更に伴い、設定を更新する必要がある場合は、以下の手順で設定を更新してください。</p>
          </v-row>
          <!--step1-->
          <v-row class="pt-3">
            <v-expansion-panels accordion v-model="panel1" id="step1">
              <v-expansion-panel>
                <v-responsive>
                  <v-expansion-panel-header class="text-h5">
                    1. MOTPhone、MOTPhone-POPUPを終了
                  </v-expansion-panel-header>
                </v-responsive>
                <v-expansion-panel-content class="py-6">
                  <ul class="explanation__list">
                    <li v-for="(item, index) in setupAndEndUsage" :key="index"
                        class="px-4 mt-6"
                        v-html="item"
                    >
                    </li>
                    <v-img src="@/assets/MOTphone1.png" width="500" class="mt-3 mb-6 motPhone__img mx-6"></v-img>
                    <li class="px-4 mt-12">【MOTPhone-POPUP終了】</li>
                    <v-img src="@/assets/MOTphone2.png" width="500" height="606" class="motPhone__img mx-6 mt-3"></v-img>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
          <!--step2-->
          <v-row class="pt-6">
            <v-expansion-panels accordion v-model="panel2" id="step2">
              <v-expansion-panel>
                <v-responsive>
                  <v-expansion-panel-header class="text-h5">
                    2. GAIAからMOTPhone更新プログラムをダウンロード
                  </v-expansion-panel-header>
                </v-responsive>
                <v-expansion-panel-content class="py-6">
                  <ul class="explanation__list">
                    <li v-for="(item, index) in downloadUsage" :key="`first-${index}`"
                        class="px-4 mt-6"
                        v-html="item"
                    >
                    </li>
                    <v-img src="@/assets/MOTphone3.png" width="500" height="340" class="motPhone__img mx-6 mt-3"></v-img>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
          <!--step3-->
          <v-row class="pt-6">
            <v-expansion-panels accordion v-model="panel3" id="step3">
              <v-expansion-panel>
                <v-responsive>
                  <v-expansion-panel-header class="text-h5">
                    3. 更新プログラム実行
                  </v-expansion-panel-header>
                </v-responsive>
                <v-expansion-panel-content class="py-6">
                  <ul class="explanation__list">
                    <li v-for="(item, index) in executionFirstUsage" :key="`first-${index}`"
                        class="px-4 mt-6"
                        v-html="item"
                    >
                    </li>
                    <v-img src="@/assets/MOTphone4.png" width="500" height="223" class="motPhone__img mx-6 mt-3 mb-9"></v-img>
                    <li v-for="(item, index) in executionSecondUsage" :key="`second-${index}`"
                        class="px-4 mt-6"
                        v-html="item"
                    >
                    </li>
                    <v-img src="@/assets/MOTphone5.png" max-width="500" height="246" class="motPhone__img mx-6 mt-3"></v-img>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
          <!--step4-->
          <v-row class="pt-6">
            <v-expansion-panels accordion v-model="panel4" id="step4">
              <v-expansion-panel>
                <v-responsive>
                  <v-expansion-panel-header class="text-h5">
                    4. 動作確認
                  </v-expansion-panel-header>
                </v-responsive>
                <v-expansion-panel-content class="py-6">
                  <ul class="explanation__list">
                    <li class="px-4">少し待つと黒い画面が終了し、<span class="d-inline-block">MOTPhoneとMOT-POPUPが起動しますので、</span><span
                        class="d-inline-block">発着信が正常に行えるか、</span><span class="d-inline-block">確認をお願いします。</span></li>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-container>
      </v-container>
    </v-sheet>
  </v-main>
</template>

<script>
import Title from '../components/Title';

export default {
  name: 'MotPhoneView',
  components: {
    Title,
  },
  computed:{
    target1 () {
      return '#step1';
    },
    target2 () {
      return '#step2';
    },
    target3 () {
      return '#step3';
    },
    target4 () {
      return '#step4';
    },
    options () {
      return {
        duration: 0,
        offset: 80,
        easing: 'easeInOutCubic',
      }
    },
  },
  data() {
    return {
      title: 'MOTPhone設定更新方法',
      img: 'title_motPhone.svg',

      imgLoadedCount: 0,

      //目次押下時のスクロール位置調整
      number: 1000,

      //デフォルトでパネルを開くための値
      panel1: 0,
      panel2: 0,
      panel3: 0,
      panel4: 0,

      //セットアップ
      setupAndEndUsage: [
        '更新前に必ずMOTPhone、<span class="d-inline-block">MOTPhone-POPUPを終了してください。</span><span class="d-inline-block">終了方法は以下の通りです。</span>',
        '【MOTPhone終了】',
      ],

      //ダウンロード
      downloadUsage: [
        'GAIAの以下フォルダを開き、<span class="d-inline-block">所属チーム名のフォルダをパソコンのデスクトップにコピーしてください。</span><p class="mt-6 mb-3">【GAIAフォルダ】</p><p class="my-3">\\\\Gaia\\全社共有\\クラウド電話\\内線設定バッチ</p><p class="red--text mt-6">別チームのフォルダを使用すると<span class="d-inline-block red--text">電話の鳴動設定が変わりますので、</span><span class="d-inline-block red--text">間違えないよう注意してください</span></p>',
      ],

      //実行
      executionFirstUsage: [
        'ダウンロードしたフォルダを開き、<span class="d-inline-block">「ExtensionSet-○○_1_2.cmd」</span><span class="d-inline-block">（○○は所属チーム名）をダブルクリックします。</span>',
        '「.cmd」の前の数字はバージョンですので、<span class="d-inline-block">都度変わります</span>',
      ],
      executionSecondUsage: [
        'ダブルクリックしたら黒い画面が表示されますので、<span class="d-inline-block">自身の内線番号を半角数字で入力し、</span><span class="d-inline-block">Enterキーを押してください。</span>',
        '自身の内線番号は<link class="d-inline-block">本リンク<a href="/mrt/telephoneOutline" target="_blank">内線・外線図</a>で</span><span class="d-inline-block">確認してください。</span><p class="red--text mt-6">内線番号を間違えると他の人と内線番号が重複し<span class="d-inline-block">電話が使用できなくなりますのでご注意ください</span></p>',
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.v-expansion-panels {
  border: 2px solid #ffffff;
  border-radius: 4px;
}

.v-expansion-panels:hover {
  border: 2px solid #0095D9;
  border-radius: 4px;
}

.explanation__list li {
  position: relative;
  list-style: none;

  &:before {
    content: '';
    width: 10px;
    height: 1px;
    background-color: #d70e19;
    position: absolute;
    top: 10px;
    left: 0;
  }
}

.explanation__detailList li {
  list-style: unset;

  &:before {
    display: none;
  }
}

.motPhone__img {
  border: solid #717170;
}

.v-expansion-panel--active {
  border: 2px solid #0095D9;
  border-radius: 2px;
}

.agenda__num {
  color: #868686;
}
.agenda__list{
  cursor: pointer;
}
</style>